var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_49_83994)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2774 18.5303L14.5305 22.2771C14.2376 22.57 13.7628 22.57 13.4699 22.2771L9.72305 18.5303C9.25057 18.0578 9.58519 17.25 10.2534 17.25H11.7502V14.25H8.75021V15.7485C8.75021 16.4165 7.94285 16.7512 7.47023 16.2792L3.71661 12.5307C3.42324 12.2377 3.42324 11.7622 3.71661 11.4693L7.47023 7.72071C7.94285 7.24873 8.75021 7.58346 8.75021 8.2514V9.74996H11.7502V6.74996H10.2516C9.58371 6.74996 9.24898 5.94261 9.72096 5.46999L13.4695 1.71637C13.7625 1.423 14.2379 1.423 14.5309 1.71637L18.2795 5.46999C18.7514 5.94261 18.4167 6.74996 17.7488 6.74996H16.2502V9.74996H19.2502V8.25312C19.2502 7.58494 20.0581 7.25032 20.5305 7.72279L24.2774 11.4696C24.5703 11.7625 24.5703 12.2374 24.2774 12.5303L20.5305 16.2771C20.0581 16.7496 19.2502 16.415 19.2502 15.7468L19.2502 14.25H16.2502V17.25H17.747C18.4152 17.25 18.7499 18.0578 18.2774 18.5303Z",
    fill: "#12131A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.064 18.75H13.2502V12.75H7.25021V13.9396L5.30796 12L7.25021 10.0603V11.25H13.2502V5.24996H12.0606L14.0002 3.30771L15.9398 5.24996H14.7502V11.25H20.7502V10.0638L22.6864 12L20.7502 13.9361V12.75H14.7502V18.75H15.9364L14.0002 20.6861L12.064 18.75ZM19.2502 15.7483C19.2514 16.4155 20.0584 16.7492 20.5305 16.2771L24.2774 12.5303C24.5703 12.2374 24.5703 11.7625 24.2774 11.4696L20.5305 7.72279C20.0581 7.25032 19.2502 7.58494 19.2502 8.25312V9.74996H16.2502V6.74996H17.7488C18.4167 6.74996 18.7514 5.94261 18.2795 5.46999L14.5309 1.71637C14.2379 1.423 13.7625 1.423 13.4695 1.71637L9.72096 5.46999C9.24898 5.94261 9.58371 6.74996 10.2516 6.74996H11.7502V9.74996H8.75021V8.2514C8.75021 7.58346 7.94285 7.24873 7.47023 7.72071L3.71661 11.4693C3.42324 11.7622 3.42324 12.2377 3.71661 12.5307L7.47023 16.2792C7.94285 16.7512 8.75021 16.4165 8.75021 15.7485V14.25H11.7502V17.25H10.2534C9.58519 17.25 9.25057 18.0578 9.72305 18.5303L13.4699 22.2771C13.7628 22.57 14.2376 22.57 14.5305 22.2771L18.2774 18.5303C18.7499 18.0578 18.4152 17.25 17.747 17.25H16.2502V14.25H19.2502L19.2502 15.7468C19.2502 15.7473 19.2502 15.7478 19.2502 15.7483Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_49_83994",
    x: 0.496582,
    y: -0.00366211,
    width: 27.0005,
    height: 27.0005,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_49_83994"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_49_83994",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorMove);
export default __webpack_public_path__ + "static/media/cursorMove.b39854308261b048d2afb4027c0540a5.svg";
export { ForwardRef as ReactComponent };